export default __webpack_public_path__ + "static/media/chicken-alfredo-fettuccini.eaadfa47.jpg";